import Logger from '../../../utils/Logger';
const { id: module_id } = module;
const logger = Logger(module_id);

const createActionName = require('../../util').createActionName(
  'user/officialServices'
);

export const REQUEST_INBOX_STATUS = createActionName('REQUEST_INBOX_STATUS');
export const FETCHING_INBOX_STATUS = createActionName('FETCHING_INBOX_STATUS');
export const GET_INBOX_STATUS_FAILED = createActionName(
  'GET_INBOX_STATUS_FAILED'
);

export const requestInboxStatus = (isActive) => ({
  type: REQUEST_INBOX_STATUS,
  payload: { isActive },
});

export const requestInboxStatusFailed = (error) => ({
  type: GET_INBOX_STATUS_FAILED,
  payload: { error },
});

export const fetchingInboxStatus = () => ({
  type: FETCHING_INBOX_STATUS,
});

export const updateInboxStatus = () => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    dispatch(fetchingInboxStatus());
    services.api
      .getSuomiFiViestitStatus()
      .then((data) => {
        resolve(dispatch(requestInboxStatus(data)));
      })
      .catch((error) => {
        logger.error(error);
        resolve(dispatch(requestInboxStatusFailed(error)));
      });
  });
};
